import { getJwtToken, setJwtToken } from "./utils/token";
import { Page, PermissionAction, PermissionLevel, UserCallPermissions } from "./types/Authorization";
import { useEffect, useState } from "react";
import { useUserPermissions } from "./contexts/UserPermissionsContext";
import Cookies from "js-cookie";

const PrivateRoute = ({
  children,
  roles,
}: {
  children: JSX.Element;
  roles: string[];
}) => {
  const token = getJwtToken();  
  var isAuthenticated = token !== null && token !== '';
  const { setUserCallPermissions,currentUser } = useUserPermissions();
  const [userCallPermissions, setUserCallPermissionsState] = useState<UserCallPermissions>({ userId:0, pages: [] });

  useEffect(() => {
  const fetchData = async () => {
    if (!isAuthenticated) {
      setJwtToken("");
      Cookies.remove('refreshToken');
      window.location.href = "/login";
    } else {
      try {
        if (!currentUser) return;

        const user = currentUser;
        const userPages = user?.pages || [];
        const userId = user?.userId;
        const updatedUserCallPermissions: UserCallPermissions = { userId, pages: [] };

        let hasAtLeastOneValidPermission = false;

        for (const role of roles) {
          const [pageName, permission] = role.split(":");
          const requestedPage = userPages.find((page: Page) => page.name.toLowerCase() === pageName.toLowerCase());

          if (requestedPage && requestedPage.permissions.toString() !== PermissionLevel.Disabled) {
            let isPermitted = false;

            if (permission === PermissionAction.CREATE) {
              isPermitted = requestedPage.permissions.create !== PermissionLevel.No;
            }
            if (permission === PermissionAction.EDIT) {
              isPermitted = requestedPage.permissions.edit !== PermissionLevel.No;
            }
            if (permission === PermissionAction.READ) {
              isPermitted = requestedPage.permissions.read !== PermissionLevel.No;
            }
            if (permission === PermissionAction.DELETE) {
              isPermitted = requestedPage.permissions.delete !== PermissionLevel.No;
            }
            if (permission === PermissionAction.REQUEST) {
              isPermitted = requestedPage.permissions.request !== PermissionLevel.No;
            }
            if (permission === PermissionAction.APPROVE) {
              isPermitted = requestedPage.permissions.approve !== PermissionLevel.No;
            }
            if (permission === PermissionAction.REPORT) {
              const reportLevel = requestedPage.permissions.report;
              isPermitted = !!reportLevel && reportLevel !== PermissionLevel.No && reportLevel !== PermissionLevel.Disabled && reportLevel !== PermissionLevel.NotSet;
            }
            if (permission === PermissionAction.DASHBOARD) {
              const dashboardLevel = requestedPage.permissions.dashboard;
              isPermitted = !!dashboardLevel && dashboardLevel !== PermissionLevel.No && dashboardLevel !== PermissionLevel.Disabled && dashboardLevel !== PermissionLevel.NotSet;
            }
            if (permission === PermissionAction.FINANCE) {
              // Previously unhandled: a route declared with a ":finance" role
              // fell through with isPermitted=false and hard-redirected
              // EVERYONE to /denied. Strict on purpose — absent/NotSet counts
              // as no finance access.
              const financeLevel = requestedPage.permissions.finance;
              isPermitted = !!financeLevel && financeLevel !== PermissionLevel.No && financeLevel !== PermissionLevel.Disabled && financeLevel !== PermissionLevel.NotSet;
            }

            if (isPermitted) {
              hasAtLeastOneValidPermission = true;
              const pageExists = updatedUserCallPermissions.pages.some(
                (page) => page.name === requestedPage.name
              );
              if (!pageExists) {
                updatedUserCallPermissions.pages.push(requestedPage);
              }
            }
          }
        }

        if (!hasAtLeastOneValidPermission) {
          window.location.href = "/denied";
        } else {
          setUserCallPermissionsState(updatedUserCallPermissions);
          setUserCallPermissions(updatedUserCallPermissions);
        }
      } catch (error) {
        console.log(error);
        setJwtToken("");
        Cookies.remove('refreshToken');
        window.location.href = "/login";
      }
    }
  };

  fetchData();
}, [isAuthenticated, token, roles, setUserCallPermissions, currentUser]);

  if (userCallPermissions && userCallPermissions.pages && userCallPermissions.pages.length > 0){
    return children;
  }
  else
  {
    return null;
  }
};

export default PrivateRoute;
